import { IonContent, IonRefresher, IonRefresherContent, RefresherEventDetail } from '@ionic/react';
import { arrowDownOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';

import { getQueryString } from '../../common/util';
import JobCardList from '../../components/jobCardList/JobCardList';
import ProfileHeader from '../../components/profileHeader/ProfileHeader';
import { IRepairOrder } from '../../models/dms/repairOrder.model';
import { RouteNames } from '../../models/routes.model';
import store from '../../store';
import { IonPageWrapper } from './JobListPage.style';

export interface IComponentProps { }

const JobListPage: React.FC<IComponentProps> = function () {
  const history = useHistory();
  const [repairOrderNumber, setRepairOrderNumber] = useState('');
  const [repairOrder, setRepairOrder] = useState<IRepairOrder>();

  const jobCardListRef = useRef<React.ElementRef<typeof JobCardList>>(null);

  useEffect(() => {
    const historyListen = history.listen((location) => {
      if (location.pathname === RouteNames.jobList) {
        const searchParams = new URLSearchParams(location.search);
        const newRepairOrderNumber = searchParams.get('repairOrderNumber') || '';
        if (repairOrderNumber !== newRepairOrderNumber) {
          setRepairOrderNumber(newRepairOrderNumber);
        }
      } else {
        setRepairOrderNumber('');
      }
    });
    const repairOrderNumberQuery = getQueryString('repairOrderNumber');
    setRepairOrderNumber(repairOrderNumberQuery);

    return () => {
      historyListen();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const repairOrderNumberQuery = getQueryString('repairOrderNumber');
    // Get the repair order from cache
    let repairOrder: IRepairOrder | undefined;
    if (repairOrderNumberQuery === 'ADHOC') {
      repairOrder = store.getState().repairOrderSync.repairOrderSync?.data.find(ro => ro.isAdhoc);
    } else {
      const roData = store.getState().repairOrderSync.repairOrderSync?.data;
      repairOrder = roData?.find(ro => ro.repairOrderNumber?.toString() === repairOrderNumberQuery && !ro.isAdhoc);
    }
    setRepairOrder(repairOrder);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [repairOrderNumber]);

  const doRefresh = (event: CustomEvent<RefresherEventDetail>) => {
    jobCardListRef.current?.loadJobsManually();

    // Add a fake "loading" progress to make it look like the app is working ;)
    setTimeout(() => {
      event.detail.complete();
    }, 100);
  };

  return (
    <IonPageWrapper>
      <ProfileHeader title="Job Detail" backButton />
      <IonContent color="lightest">
        <IonRefresher slot="fixed" onIonRefresh={(event) => doRefresh(event)}>
          <IonRefresherContent pullingIcon={arrowDownOutline} pullingText="" refreshingSpinner={'lines'} refreshingText="" />
        </IonRefresher>
        {repairOrder && <JobCardList ref={jobCardListRef} repairOrder={repairOrder} />}
      </IonContent>
    </IonPageWrapper>
  );
};

export default JobListPage;
